export enum Hcc2Id {
    MAHCC_V28_2024 = 37,
    MAHCC_V28_2025 = 40,
    MAHCC_V28 = 45,
}
